export default {
  "map": {
    "config": {
      "changed": false,
      "title": "Map",
      "navSection": "map",
      "icon": "map",
      "image": "map.png"
    },
    "items": {
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 12
      },
      "dataPoint": {
        "showAllDataPoints": true,
        "fill": "#01B1AA",
        "transparency": null
      },
      "categoryLabels": {
        "show": true,
        "color": "#EEEEEE",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "enableBackground": true,
        "backgroundColor": "#252423",
        "backgroundTransparency": 50
      },
      "bubbles": {
        "bubbleSize": 0
      },
      "mapControls": {
        "autoZoom": true,
        "zoomLevel": 4,
        "centerLatitude": 43,
        "centerLongitude": -83
      },
      "mapStyles": {
        "mapTheme": "grayscale",
        "showLabels": true
      },
      "heatMap": {
        "show": false,
        "filterRadius": 10,
        "transparency": 0,
        "color0": "#108CFF",
        "color": "#0B5EAB",
        "color100": "#052F56"
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "filledMap": {
    "config": {
      "changed": false,
      "title": "Filled Map",
      "navSection": "map",
      "icon": "filledMap",
      "image": "filledMap.png"
    },
    "items": {
      "legend": {
        "show": true,
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "defaultColor": "#252423",
        "fontFamily": "Segoe UI Light",
        "fontSize": 10
      },
      "dataPoint": {
        "fill": "#01B1AA",
        "transparency": null,
        "showAllDataPoints": true
      },
      "mapControls": {
        "autoZoom": true,
        "zoomLevel": 4,
        "centerLatitude": 43,
        "centerLongitude": -83
      },
      "mapStyles": {
        "mapTheme": "grayscale",
        "showLabels": true
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "multiRowCard": {
    "config": {
      "changed": true,
      "title": "Multi-row Card",
      "navSection": "map",
      "icon": "multiRowCard",
      "image": "multiRowCard.png"
    },
    "items": {
      "labels": {
        "color": "#03176d",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 11,
        "fontFamily": "Segoe (Bold)",
        "preserveWhitespace": true,
        "show": null,
        "labelOrientation": null,
        "labelPosition": null,
        "labelOverflow": null,
        "labelDensity": null
      },
      "categoryLabels": {
        "show": true,
        "color": "#03176d",
        "fontSize": 8,
        "fontFamily": "Segoe UI"
      },
      "cardTitle": {
        "color": "#03176d",
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "card": {
        "outline": "None",
        "outlineColor": "#cccccc",
        "outlineWeight": 1,
        "barShow": false,
        "barColor": "#5e78e5",
        "barWeight": 1,
        "cardPadding": 20,
        "cardBackground": "rgba(238,238,238,0)"
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#03176d",
        "background": "rgba(255,255,255,0)",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI Light"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": true,
        "color": "#cccccc",
        "radius": 8
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualHeader": {
        "show": true,
        "background": "#020f47",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 60,
        "foreground": "#efefef",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  },
  "shapeMap": {
    "config": {
      "changed": false,
      "title": "Shape Map",
      "navSection": "map",
      "icon": "shapeMap",
      "image": "shapeMap.png"
    },
    "items": {
      "dataPoint": {
        "fill": "#252423",
        "transparency": null,
        "showAllDataPoints": true
      },
      "legend": {
        "show": true,
        "style": "MarkersOnly",
        "position": "Top",
        "showTitle": true,
        "titleText": "",
        "legendColor": "#252423",
        "fontFamily": "Segoe UI",
        "fontSize": 12
      },
      "shape": {
        "projectionEnum": "mercator"
      },
      "defaultColors": {
        "defaultShow": true,
        "defaultColor": "#DDDDDD",
        "borderColor": "#222222",
        "borderThickness": 1
      },
      "zoom": {
        "autoZoom": true,
        "selectionZoom": true,
        "manualZoom": true
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "gauge": {
    "config": {
      "changed": false,
      "title": "Gauge",
      "navSection": "map",
      "icon": "gauge",
      "image": "gauge.png"
    },
    "items": {
      "axis": {
        "min": 11,
        "max": 100,
        "target": 101
      },
      "dataPoint": {
        "fill": "#252423",
        "target": "#FFB8DD"
      },
      "labels": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Segoe UI"
      },
      "target": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1,
        "fontSize": 11,
        "fontFamily": "Segoe UI"
      },
      "calloutValue": {
        "show": true,
        "color": "#EEEEEE",
        "labelDisplayUnits": "0",
        "labelPrecision": 1
      },
      "title": {
        "show": true,
        "text": "",
        "titleWrap": false,
        "fontColor": "#252423",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontFamily": "Segoe UI",
        "fontSize": 10
      },
      "background": {
        "show": true,
        "color": "#252423",
        "transparency": 20
      },
      "lockAspect": {
        "show": true
      },
      "border": {
        "show": true,
        "color": "#252423",
        "radius": 20
      },
      "dropShadow": {
        "show": true,
        "color": "#252423",
        "position": "Outer",
        "preset": "TopRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": false,
        "titleFontColor": "#252423",
        "valueFontColor": "#252423",
        "actionFontColor": "#252423",
        "fontSize": 12,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      },
      "visualHeader": {
        "show": true,
        "background": "#ffffff",
        "border": "#9b8080",
        "transparency": 2,
        "foreground": "#4d4d4d",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#ffffff",
        "transparency": 5
      }
    }
  },
  "card": {
    "config": {
      "changed": true,
      "title": "Card",
      "navSection": "map",
      "icon": "card",
      "image": "card.png"
    },
    "items": {
      "labels": {
        "color": "#03176d",
        "labelDisplayUnits": "0",
        "labelPrecision": 0,
        "fontSize": 24,
        "fontFamily": "Segoe (Bold)",
        "preserveWhitespace": true,
        "show": true,
        "labelOrientation": null,
        "labelPosition": null,
        "labelOverflow": null,
        "labelDensity": null
      },
      "categoryLabels": {
        "show": true,
        "color": "#03176d",
        "fontSize": 9,
        "fontFamily": "Segoe UI"
      },
      "wordWrap": {
        "show": true
      },
      "title": {
        "show": false,
        "text": "",
        "titleWrap": true,
        "fontColor": "#020f47",
        "background": "#FFFFFF",
        "alignment": "left",
        "fontSize": 10,
        "fontFamily": "Segoe UI"
      },
      "background": {
        "show": true,
        "color": "#FFFFFF",
        "transparency": 100
      },
      "lockAspect": {
        "show": false
      },
      "border": {
        "show": false,
        "color": "#000000",
        "radius": 0
      },
      "dropShadow": {
        "show": false,
        "color": "#252423",
        "position": "Outer",
        "preset": "BottomRight",
        "shadowSpread": 3,
        "shadowBlur": 10,
        "angle": 45,
        "shadowDistance": 10,
        "transparency": 70
      },
      "visualTooltip": {
        "show": true,
        "type": "Report page",
        "titleFontColor": "#020f47",
        "valueFontColor": "#020f47",
        "actionFontColor": "#020f47",
        "fontSize": 10,
        "fontFamily": "Segoe UI",
        "background": "#e6e6e6",
        "transparency": 5,
        "page": "Auto"
      },
      "visualHeader": {
        "show": true,
        "background": "#FFFFFF",
        "border": {
          "solid": {
            "color": "#FFFFFF"
          }
        },
        "transparency": 30,
        "foreground": "#98918b",
        "showVisualInformationButton": true,
        "showVisualWarningButton": true,
        "showVisualErrorButton": true,
        "showDrillRoleSelector": true,
        "showDrillUpButton": true,
        "showDrillToggleButton": true,
        "showDrillDownLevelButton": true,
        "showDrillDownExpandButton": true,
        "showPinButton": true,
        "showFocusModeButton": true,
        "showFilterRestatementButton": true,
        "showSeeDataLayoutToggleButton": true,
        "showOptionsMenu": true,
        "showTooltipButton": false
      },
      "visualHeaderTooltip": {
        "text": "",
        "titleFontColor": "#C8C8C8",
        "fontSize": 9,
        "fontFamily": "Segoe UI",
        "background": "#333333",
        "transparency": 5
      }
    }
  }
}